/**
 * ChargeListPresenter
 * --
 */
import React, { useEffect, useState } from 'react';
import { Content, Title, Row, Col, Information } from 'components';
import {
  // Input,
  InputNumber,
  Button,
  Avatar,
  Radio,
  Descriptions,
  Divider,
  Empty,
  Spin,
  Input,
} from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { stringToMoneyFormat } from 'utils';
import ShopInformationList from 'routes/admin.routes/admin.orders/OrderList/components/ShopInformationList';

/**----------------------------------------
 * [Component] 수수료관리: 프레젠터
 * ----------------------------------------
 */
const ChargeListPresenter = ({
  // shopList,
  // currentShop,
  setCurrentShop,
  categoryList,
  productList,
  /* 선택항목 */
  selectedCategory,
  setSelectedCategory,
  selectedProduct,
  setSelectedProduct,

  productPolicy,
  loading,
  onSaveCommission,
  shop,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [commissionInfo, setCommissionInfo] = useState({
    commission_rate: 0,
    commission_type: 'R', // [R: 비율, W: 원화 고정값]
  });
  const [keyword, setKeyword] = useState({
    product_category_name: '',
    product_name: '',
  });
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  const handleChangeCommissionInfo = (key, val) => {
    setCommissionInfo((p) => ({ ...p, [key]: val }));
  };
  /* ===== HOOKS ===== */
  /* 업체 선택 시 수수료정보 변경 */
  useEffect(() => {
    shop &&
      setCommissionInfo({
        commission_rate: shop.commission_rate,
        commission_type: shop.commission_type,
      });
  }, [shop]);

  /* 카테고리 선택 시 수수료정보 변경 */
  useEffect(() => {
    selectedCategory &&
      setCommissionInfo({
        commission_rate: selectedCategory.commission_rate,
        commission_type: selectedCategory.commission_type,
      });
  }, [selectedCategory]);

  /* 상품 선택 시 수수료정보 변경 */
  useEffect(() => {
    setCommissionInfo({
      commission_rate: productPolicy ? productPolicy.commission_rate : 0,
      commission_type: productPolicy ? productPolicy.commission_type : 'R',
    });
  }, [productPolicy]);

  /* ===== RENDER ===== */

  /* 선택된 카테고리에 해당하는 상품만 필터링 */

  /**
   * 검색어 필터
   * @param {*} key
   * @param {*} val
   */
  const handleChangeKeyword = (key, val) => {
    setKeyword((p) => ({ ...p, [key]: val }));
  };
  //NOTE: 검색 필터 추가
  const { newCategoryList, newProductListFiltered } = React.useMemo(() => {
    let categoryListData = categoryList
      .map((category) => {
        const count = productList.filter(
          (product) =>
            product.product_category_id === category.product_category_id
        ).length;

        return {
          ...category,
          product_count: count,
        };
      })
      ?.filter((item) => item.type === 'PRODUCT');

    let productListFilteredData = selectedCategory
      ? productList.filter(
          (item) =>
            item.product_category_id === selectedCategory?.product_category_id
        )
      : [];

    const { product_category_name, product_name } = keyword;
    if (product_category_name) {
      categoryListData = categoryListData.filter((item) =>
        item.product_category_name.includes(keyword.product_category_name)
      );
    }
    if (product_name) {
      productListFilteredData = productListFilteredData.filter((item) =>
        item.product_name.includes(keyword.product_name)
      );
    }
    return {
      newCategoryList: categoryListData,
      newProductListFiltered: productListFilteredData,
    };
  }, [categoryList, selectedCategory, keyword]);

  // JSX
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title size={3} style={{ marginBottom: 10 }}>
            수수료 관리
          </Title>

          <Spin spinning={loading}>
            <Content
              maxWidth={'100%'}
              padding={0}
              backgroundColor={'none'}
              className="boxShadow"
            >
              <Row
                style={{
                  minHeight: '80vh',
                }}
              >
                {/* 업체목록 */}
                <Col
                  x={4}
                  style={{
                    ...styles.shopListWrapper,
                    maxHeight: '84vh',
                    overflowY: 'scroll',
                  }}
                >
                  <ShopInformationList
                    onChange={(key) => setCurrentShop(key)}
                  />

                  {/* <Content
                    maxWidth={'100%'}
                    padding={10}
                    style={styles.shopListWrapper_search}
                  >
                    <Input placeholder="업체명을 입력해주세요" />
                  </Content> */}

                  {/* <Content maxWidth={'100%'} padding={0}>
                    <Content
                      maxWidth={'100%'}
                      height={'calc(100% + 48px)'}
                      padding={5}
                      className="boxShadow"
                    >
                      <TabMenu
                        items={shopList.map((item) => ({
                          ...item,
                          key: item.shop_information_id,
                          activeKey: item.shop_information_id,
                          label: (
                            <>
                              <p className="cursorOverOpacity">
                                {item.shop_information_name}
                                <br />
                                <span
                                  style={{
                                    fontWeight: '400',
                                    color: '#9a9a9a',
                                  }}
                                >
                                  {item?.store_information?.business_num ?? ''}{' '}
                                  {item?.store_information?.store_owner
                                    ? `(${item?.store_information?.store_owner})`
                                    : ''}
                                </span>
                              </p>
                            </>
                          ),
                        }))}
                        activeKey={'shop_information_id'}
                        collapseKey={'shop_information_id'}
                        onChange={({ key }) => setCurrentShop(key)}
                      />
                    </Content>
                  </Content> */}
                </Col>
                {/* 업체목록 끝 */}

                {/* === 카테고리 목록 start === */}
                <Col x={4} style={styles.categoryList}>
                  {!shop ? (
                    <>
                      <br />
                      <br />
                      <Empty description="업체를 선택해주세요" />
                    </>
                  ) : (
                    <Content
                      maxWidth={'100%'}
                      padding={0}
                      backgroundColor="none"
                      style={{
                        maxHeight: '84vh',
                        overflowY: 'scroll',
                      }}
                    >
                      <Content
                        maxWidth={'100%'}
                        padding={10}
                        style={{ borderBottom: '1px solid #EBEBEB' }}
                      >
                        <Input
                          placeholder="카테고리 명을 입력해주세요"
                          allowClear
                          value={keyword.product_category_name}
                          onChange={(e) =>
                            handleChangeKeyword(
                              'product_category_name',
                              e.target.value
                            )
                          }
                        />
                      </Content>

                      <div
                        className="cursorOverOpacity"
                        style={{
                          ...styles.listWrapper,
                          ...(selectedCategory === null
                            ? styles.activeItem
                            : styles.defaultItem),
                        }}
                        onClick={() => setSelectedCategory(null)}
                      >
                        <div style={styles.listwrapper2}>
                          <p style={{ fontWeight: '600' }}>선택안함</p>
                        </div>
                      </div>
                      {newCategoryList.map((_item, _index) => (
                        <div
                          key={`product_${_index}`}
                          className="cursorOverOpacity"
                          style={{
                            ...styles.listWrapper,
                            ...(selectedCategory?.product_category_id ===
                            _item.product_category_id
                              ? styles.activeItem
                              : styles.defaultItem),
                          }}
                          onClick={() => setSelectedCategory(_item)}
                        >
                          <div style={styles.listwrapper2}>
                            <p style={{ fontWeight: '600' }}>
                              {_item.parents_id && (
                                <span
                                  style={{ opacity: 0.5 }}
                                >{`하위 > `}</span>
                              )}
                              {_item.product_category_name} (
                              {_item?.product_count})
                            </p>
                            {/* <p>수수료: {_item.commission_rate}%</p> */}
                          </div>
                        </div>
                      ))}
                    </Content>
                  )}
                </Col>
                {/* === 카테고리 목록 end === */}

                {/* === 상품목록 start === */}
                <Col x={4} style={styles.productList}>
                  {!selectedCategory ? (
                    <>
                      <br />
                      <br />
                      <Empty description="카테고리를 선택해주세요" />
                    </>
                  ) : (
                    <Content
                      maxWidth={'100%'}
                      padding={0}
                      backgroundColor="none"
                      style={{
                        maxHeight: '84vh',
                        overflowY: 'scroll',
                      }}
                    >
                      <Content
                        maxWidth={'100%'}
                        padding={10}
                        style={{ borderBottom: '1px solid #EBEBEB' }}
                      >
                        <Input
                          placeholder="상품명 명을 입력해주세요"
                          allowClear
                          value={keyword.product_name}
                          onChange={(e) =>
                            handleChangeKeyword('product_name', e.target.value)
                          }
                        />
                      </Content>
                      <div
                        className="cursorOverOpacity"
                        style={{
                          ...styles.listWrapper,
                          ...(selectedProduct === null
                            ? styles.activeItem
                            : styles.defaultItem),
                        }}
                        onClick={() => setSelectedProduct(null)}
                      >
                        <div>
                          <Avatar
                            size={30}
                            shape="square"
                            style={{ opacity: 0.35 }}
                          />
                        </div>

                        <div style={styles.listwrapper2}>
                          <p style={styles.txt}>선택안함</p>
                        </div>
                      </div>
                      {newProductListFiltered.map((_item, _index) => (
                        <div
                          key={`product_${_index}`}
                          className="cursorOverOpacity"
                          style={{
                            ...styles.listWrapper,
                            ...(selectedProduct?.product_id === _item.product_id
                              ? styles.activeItem
                              : styles.defaultItem),
                          }}
                          onClick={() => setSelectedProduct(_item)}
                        >
                          <div>
                            <Avatar
                              size={30}
                              shape="square"
                              style={{ opacity: 0.35 }}
                            />
                          </div>
                          <div style={styles.listwrapper2}>
                            <p style={styles.txt}>{_item.product_name}</p>
                            {/* <p>금액: {stringToMoneyFormat(_item.price)}원</p> */}
                          </div>
                        </div>
                      ))}
                    </Content>
                  )}
                </Col>
                {/* === 상품목록 end === */}

                {/* 수수료 설정 */}
                <Col
                  x={12}
                  style={{
                    overflowY: 'auto',
                    borderRight: '1px solid #EBEBEB',
                    background: '#FFFFFF',
                  }}
                >
                  {/* === 수수료 섫정 폼 start === */}
                  <Content maxWidth={'100%'} padding={0}>
                    <Content maxWidth={'100%'} padding={15}>
                      <Title size={4}>수수료 설정</Title>
                      <Divider style={{ margin: '15px 0' }} />
                      <Information
                        content={[
                          '오늘 입금될 상품 결제대금과 과거 정산내역, 상품주문별 상세 정산내역을 확인하실 수 있습니다.',
                          '상품주문별 결제대금 및 수수료와 관련된 결제대금 정산, 할인/적립과 관련된 혜택정산, 상품 판매대금에 연계되지 못하고 적용되는 일별/공제 환급, 지급보류 금액을 확인하실 수 있습니다.',
                          '판매 내역은 부가세신고를 돕기 위한 참고 자료를 확인하실 수 있습니다.'
                        ]}
                      />
                      <br />
                      {shop ? (
                        <>
                          <Descriptions
                            column={2}
                            size="small"
                            bordered
                            labelStyle={{ width: 150 }}
                            items={[
                              {
                                key: `1`,
                                label: '구분',
                                span: 2,
                                children: (
                                  <p>
                                    {/* 업체명 */}
                                    {shop?.shop_information_name ?? ''}
                                    {/* 카테명 */}
                                    {selectedCategory?.product_category_name
                                      ? ` > ${selectedCategory.product_category_name}`
                                      : ''}
                                    {/* 상품명 */}
                                    {selectedProduct?.product_name
                                      ? ` > ${selectedProduct.product_name}`
                                      : ''}
                                  </p>
                                ),
                              },
                              {
                                key: `2`,
                                label: '적용단위',
                                span: 2,
                                children: (
                                  <Radio.Group
                                    value={commissionInfo.commission_type}
                                    defaultValue={
                                      commissionInfo.commission_type
                                    }
                                    onChange={(e) =>
                                      handleChangeCommissionInfo(
                                        'commission_type',
                                        e.target.value
                                      )
                                    }
                                  >
                                    <Radio value={'R'}>비율</Radio>
                                    <Radio value={'W'}>금액</Radio>
                                  </Radio.Group>
                                ),
                              },
                              {
                                key: `3`,
                                label: '수수료',
                                span: 2,
                                children: (
                                  <>
                                    <InputNumber
                                      value={commissionInfo.commission_rate}
                                      onChange={(e) =>
                                        handleChangeCommissionInfo(
                                          'commission_rate',
                                          e >= 0 ? e : 0
                                        )
                                      }
                                      addonAfter={
                                        commissionInfo.commission_type === 'R'
                                          ? '%'
                                          : '원'
                                      }
                                      style={{
                                        width: 120,
                                      }}
                                      placeholder="0.0"
                                      max={
                                        commissionInfo.commission_type === 'R'
                                          ? 100
                                          : selectedProduct
                                          ? selectedProduct?.price
                                          : null
                                      }
                                    />
                                  </>
                                ),
                              },
                              ...(selectedProduct
                                ? [
                                    {
                                      key: `4`,
                                      label: '상품금액',
                                      contentStyle: { width: 230 },
                                      children: (
                                        <p>
                                          {stringToMoneyFormat(
                                            selectedProduct.price
                                          )}
                                          원
                                        </p>
                                      ),
                                    },
                                    {
                                      key: `5`,
                                      label: '예상수수료',
                                      children: (
                                        <p>
                                          {commissionInfo.commission_type ===
                                          'R'
                                            ? selectedProduct.price *
                                              (commissionInfo.commission_rate /
                                                100)
                                            : commissionInfo.commission_rate}
                                          원
                                        </p>
                                      ),
                                    },
                                  ]
                                : []),
                            ]}
                          />
                          <div
                            style={{
                              marginTop: 20,
                              textAlign: 'center',
                            }}
                          >
                            <Button
                              type="primary"
                              onClick={() => onSaveCommission(commissionInfo)}
                            >
                              <SaveOutlined /> 저장
                            </Button>
                          </div>
                        </>
                      ) : (
                        <Empty description="업체를 선택해주세요" />
                      )}
                    </Content>
                  </Content>
                  {/* === 수수료 섫정 폼 end === */}
                </Col>
                {/* 수수료 설정 끝 */}
              </Row>
            </Content>
          </Spin>
        </Col>
      </Row>
    </Content>
  );
};

const styles = {
  title: {
    fontSize: 24,
    fontWeight: 700,
    marginBottom: 20,
  },
  form: {
    input: {
      large: {
        width: 175,
        marginRight: 8,
      },
      medium: {
        width: 100,
        marginRight: 8,
      },
    },
    button: {
      marginRight: 8,
    },
    date: {
      width: 120,
    },
    text: {
      fontSize: 13,
      fontWeight: 400,
    },
  },

  shopListWrapper: {
    borderRight: '1px solid #EBEBEB',
    background: '#FFFFFF',
  },
  shopListWrapper_search: { borderBottom: '1px solid #EBEBEB' },

  categoryList: {
    borderRight: '1px solid #EBEBEB',
    background: '#fafafa',
    overflowY: 'auto',
  },
  productList: {
    overflowY: 'auto',
    borderRight: '1px solid #EBEBEB',
    background: '#f3f3f3',
  },
  listWrapper: {
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    height: 48,
    cursor: 'pointer',
  },
  listwrapper2: {
    paddingLeft: 7,
    color: '#313131',
    fontSize: '0.9em',
  },

  activeItem: {
    border: '1px solid #2394E4',
    borderBottom: '1px solid #2394E4',
    background: 'rgba(28, 107, 244, 0.15)',
  },
  defaultItem: {
    border: '1px solid #ededed',
    borderBottom: '1px solid #DFDFDF',
    background: 'none',
  },
  txt: { fontWeight: '600' },
};

export default ChargeListPresenter;
